import React, { useRef, useState } from 'react';
import { TextField, Button, Box, Typography, Dialog, CircularProgress, Zoom, DialogContent, Alert } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import { EqForm } from '../../../hooks/apiHandler';
import { CheckCircleOutline } from '@mui/icons-material';
import { set } from 'date-fns';

const ContactForm = ({ onClose }) => {
  const intFormData = {
    name: '',
    email: '',
    phone: '',
    cityName: '',
    businessName: '',
  };
  const [formData, setFormData] = useState(intFormData);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [statusMsg, setStatusMsg] = useState({ show: false, text: '', type: 'info' });
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setStatusMsg({ 
        show: true, 
        text: 'Please complete the reCAPTCHA.', 
        type: 'warning' 
      });
      return;
    }

    setLoading(true);
    setStatusMsg({ show: false, text: '', type: 'info' });

    try {
      var dataTosend = {
        ...formData, captchaToken
      }
      const response = await EqForm(dataTosend);
      console.log(dataTosend);
      console.log('Success:', response);
      setLoading(false);
      setSuccess(true);

      // Wait for 5 seconds, then close and trigger parent callback
      setTimeout(() => {
        setSuccess(false);
        setFormData(intFormData); // Reset form after success
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        if (onClose) onClose();
      }, 5000);
    } catch (error) {
      console.error('Error submitting contact form:', error);
      alert('There was an error submitting the form. Please try again.');
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mx: 'auto',
        p: 4,
        borderRadius: 2
      }}
    >
      {statusMsg.show && (
        <Alert
          severity={statusMsg.type} 
          onClose={() => setStatusMsg({ ...statusMsg, show: false })}
          sx={{ borderRadius: '12px', mb: 1 }}
        >
          {statusMsg.text}
        </Alert>
      )}
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="name"
        label="Name"
        placeholder="Enter your name"
        value={formData.name}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="email"
        label="Email"
        type="email"
        placeholder="Enter your email"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="phone"
        label="Phone Number"
        type="tel"
        placeholder="Enter your phone number"
        value={formData.phone}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="cityName"
        label="City Name"
        placeholder="Enter your City Name"
        value={formData.cityName}
        onChange={handleChange}
        required
      />
      <TextField
        sx={{ borderRadius: '20px !important' }}
        name="businessName"
        label="Business Name"
        placeholder="Enter your Business Name"
        value={formData.businessName}
        onChange={handleChange}
        required
      />

      <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6LfAJIsrAAAAAMYx3GqDOPPYzZsGKasAj_xPkQwU"
          onChange={handleCaptcha}
        />
      </Box>

      <Button
        sx={{
          background: 'tomato',
          borderRadius: '20px',
          py: 1.5,
          fontWeight: 'bold',
          transition: '0.3s',
          '&:hover': { background: '#e5634d', transform: 'translateY(-2px)' }
        }}
        type="submit"
        variant="contained"
        disabled={loading || success}
        fullWidth
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Submit Request"}
      </Button>

      <Typography variant="caption" color="text.secondary" align="center">
        Our specialist will contact you to set up your free demo.
      </Typography>

      {/* SUCCESS DIALOG (5 SECOND DURATION) */}
      <Dialog
        open={success}
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            borderRadius: '24px',
            textAlign: 'center',
            p: 4,
            maxWidth: '380px'
          }
        }}
      >
        <DialogContent>
          <CheckCircleOutline sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: 'text.primary' }}>
            Request Successful!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Thank you for choosing MiiRA POS. Our expert will contact you within the next 24 hours to schedule your demo.
          </Typography>
          <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
            This message will close automatically...
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
export default ContactForm;
